module.exports = __webpack_public_path__ + "img/male.a258b2b9.svg";